app.controller("DefineSessionGroupController", [
    "$scope", "Session", "TimetableService", "StaticData", "$stateParams", "$uibModalInstance", "sessionGroup", "toastr",
    function ($scope, Session, TimetableService, StaticData, $stateParams, $uibModalInstance, sessionGroup, toastr) {
        $scope.sessionStartTime = new Date(2019, 0, 0, 9, 0);
        $scope.room = {};
        $scope.sessionDayOfWeek = {};
        $scope.mySessions = sessionGroup.sessions.filter(function(session){
            return !!session._id
        });
        $scope.sessionRoom = '';
        $scope.duration = sessionGroup.duration;
        $scope.sessionGroup = sessionGroup;

        StaticData.getItemsByKey("days").then(function (days) {
            $scope.days = days;
            $scope.daysMap = _.keyBy($scope.days, '_id');
        });

        StaticData.getItemsByKey("buildings").then(function (buildings) {
            $scope.buildings = [{name: "კორპუსი"}].concat(buildings);
            $scope.buildingsMap = _.keyBy($scope.buildings, '_id');
        });

        StaticData.getItemsByKey("session_types").then(function (types) {
            $scope.types = types;
            $scope.sessionType = types[0]
        });

        $scope.hours = _.range(1, 9);
        $scope.times = _.range(7, 23);

        $scope.getRooms = function (query) {
            return TimetableService.fetchRooms(query).then(function (rooms) {
                for (var i in rooms) {
                    if (rooms[i].building == 'building01') rooms[i].buildingName = 'I კორპუსი';
                    if (rooms[i].building == 'building02') rooms[i].buildingName = 'II კორპუსი';
                }
                return rooms;
            });
        };

        $scope.save = function () {
            if ($scope.mySessions.length > $scope.sessionGroup.duration) return toastr.error('', 'სესიების რაოდენობა მეტია დასაშვებზე');
            if ($scope.mySessions.length < $scope.sessionGroup.duration) return toastr.error('', 'სესიების რაოდენობა ნაკლებია დასაშვებზე');
            else {
                TimetableService.insertGroup({
                    sessions: $scope.mySessions,
                    group: $scope.sessionGroup._id
                }).then(function (res) {
                    console.log('TimetableService.insertGroup - RES - ', res);
                    toastr.success('', 'სესიის ჯგუფი წარმატებით განისაზღვრა ცხრილში');
                    $uibModalInstance.close();
                });
            }
        };

        $scope.add = function (sessionGroup) {
            if (!$scope.sessionDayOfWeek.name) return toastr.error('', 'გთხოვთ მიუთითოთ კვირის დღე');
            if (!$scope.sessionRoom) return toastr.error('', 'გთხოვთ მიუთითოთ აუდიტორია');
            if (!$scope.sessionRoom._id) return toastr.error('', 'ასეთი აუდიტორია არ არსებობს');
            if ($scope.mySessions.length === sessionGroup.duration) return toastr.error('', 'სესიის ჯგუფში შეიძლება დაემატოს მხოლოდ ' + sessionGroup.duration + ' სესია');
            var startTime = new Date(Date.parse($scope.sessionStartTime));

            $scope.check(sessionGroup, [{
                dayOfWeek: $scope.sessionDayOfWeek._id,
                startTime: startTime,
                room: $scope.sessionRoom._id
            }]).then(function (res) {

                for (var i in $scope.mySessions) {
                    if ($scope.mySessions[i].dayOfWeek == $scope.sessionDayOfWeek._id && new Date($scope.mySessions[i].startTime).getTime() == startTime.getTime() && $scope.mySessions[i].room.name == $scope.sessionRoom.name) {
                        return toastr.error('', 'სესია ამ მონაცემებით უკვე დამატებულია');
                    }
                }
                if (!res.lecturers.length && res.rooms.length) return toastr.error('', 'ოთახი დაკავებულია');
                else if (res.lecturers.length && !res.rooms.length) return toastr.error('', 'ლექტორი დაკავებულია');
                else if (res.lecturers.length && res.rooms.length) return toastr.error('', 'ოთახი და ლექტორი დაკავებულია');
                else if (!res.lecturers.length && !res.rooms.length) {
                    $scope.mySessions.push({
                        dayOfWeek: $scope.sessionDayOfWeek._id,
                        startTime: startTime,
                        room: $scope.sessionRoom
                    });
                    var time = $scope.sessionStartTime.setHours($scope.sessionStartTime.getHours() + 1);
                    $scope.sessionStartTime = new Date(time);
                };
            });
        };

        $scope.remove = function (day) {
            var index = $scope.mySessions.indexOf(day);
            $scope.mySessions.splice(index, 1)
        };

        $scope.check = function (sessionGroup, sessions) {
            return TimetableService.check({
                sessionGroup: sessionGroup,
                sessions: sessions
            }).then(function (res) {
                return res;
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);